import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';
import { potentialViolationsTenantColumns, driverStatusTableColumns } from './columnMapping';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ comSummaryItems }) => {
  return {
    potentialViolations_columns: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => potentialViolationsTenantColumns.columns[SERVICE_PROVIDERS.WEBFLEET],
      default: () => potentialViolationsTenantColumns.columns['default'],
    },
    alerts_descriptionLink: {
      [SERVICE_PROVIDERS.SPIREON]: () => false,
      default: () => true,
    },
    component_alerts: {
      [SERVICE_PROVIDERS.SPIREON]: () => false,
      default: () => hasRestrictedRole([ROLES.OWNER]),
    },
    component_potentialViolations: {
      [SERVICE_PROVIDERS.SPIREON]: () => false,
      default: () => true,
    },
    component_dailyLogs: {
      [SERVICE_PROVIDERS.SPIREON]: () => false,
      default: () => true,
    },
    config_driverStatusTableColumns: {
      [SERVICE_PROVIDERS.RADIUS]: () => driverStatusTableColumns.columns[SERVICE_PROVIDERS.RADIUS],
      [SERVICE_PROVIDERS.TWOBRO]: () => driverStatusTableColumns.columns[SERVICE_PROVIDERS.TWOBRO],
      [SERVICE_PROVIDERS.NAUTO]: () => driverStatusTableColumns.columns[SERVICE_PROVIDERS.NAUTO],
      [SERVICE_PROVIDERS.TTS]: () => driverStatusTableColumns.columns[SERVICE_PROVIDERS.TTS],
      default: () => driverStatusTableColumns.columns['default'],
    },
    driverStatus_generateRows: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      default: () => false,
    },
    header_list: {
      [SERVICE_PROVIDERS.SPIREON]: () => comSummaryItems.slice(0, 5),
      default: () => comSummaryItems,
    },
    updateDriverStatus: {
      [SERVICE_PROVIDERS.SPIREON]: () => true,
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.TWOBRO]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    renderComponent: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      default: () => true,
    },
    notification_newUI: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    overrideComp_findAndDeleteParentInJson: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      [SERVICE_PROVIDERS.AZUGA]: () => true,
      default: () => false,
    },
    overrideComp_sourceToDisplay: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      [SERVICE_PROVIDERS.AZUGA]: () => true,
      default: () => false,
    },
    overrideComp_sourceToDisplay_filter: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    overrideComp_rowItem_eld: {
      [SERVICE_PROVIDERS.RADIUS]: () => true,
      [SERVICE_PROVIDERS.NAUTO]: () => true,
      [SERVICE_PROVIDERS.TWOBRO]: () => true,
      [SERVICE_PROVIDERS.TTS]: () => true,
      default: () => false,
    },
    overrideComp_googlemap: {
      [SERVICE_PROVIDERS.RADIUS]: () => false,
      [SERVICE_PROVIDERS.TWOBRO]: () => false,
      [SERVICE_PROVIDERS.TTS]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      [SERVICE_PROVIDERS.AZUGA]: () => false,
      default: () => true,
    },
    overrideComp_Tab: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      [SERVICE_PROVIDERS.AZUGA]: () => true,
      default: () => false,
    },
    overrideComp_driverBehavior: {
      [SERVICE_PROVIDERS.AT]: () => true,
      [SERVICE_PROVIDERS.SIMPLEX]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
